<template>
  <v-col cols="12">
    <v-list>
      <v-list-item>
        <v-list-item-action>
          <v-checkbox
            v-model="template.isSelected"
            label=""
            style="margin: 0;"
            hide-details
            :class="template.isSelected && 'template--selected'"
          ></v-checkbox>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title
            @click="openTemplate"
            style="display: flex; justify-content: space-between; cursor:pointer;"
          >
            <div>{{template.name}}</div>
            <div style="font-size: 10px; color: #777;">
              {{ timestampFormatted }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle style="display: flex; justify-content: space-between">
            <div>{{template.description}}</div>
            <v-chip
                v-if="template.isPublished"
                color="green"
                text-color="white"
                x-small
                style="position: absolute; bottom: 2px; right: 20px; font-size: 12px;"
            >
              {{ translate('ui_is_published') }}
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>
<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplateGalleryListItem',
  props: {
    template: {},
    onTemplateGalleryItemClick: Function,
    timestampFormatted: String,
  },
  mixins: [Mixin],
  computed: {},
  methods: {
    openTemplate() {
      this.$router.push(`/template/${this.template.uuid}`);
    },
  },
};
</script>
